import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as api from 'core/api';
import * as flights from 'core/flights';
import * as utils from 'core/utils';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export class OnlineRegistrationComponent extends Vue {
    @Prop()
    gaParams: utils.GoogleAnalyticsParams;

    @Prop()
    gaAlreadySubmitted: string[];

    isProductSelected: string = 'n';

    mounted() {
        (<any>this).$ga.sendEvent('online.registration', 'display', 'online.registration.display');
    }

    onProductSelectionChange() {
        if (this.isProductSelected === 'y') {
            (<any>this).$ga.sendEvent('online.registration', 'btn.ok', 'online.registration.btn.ok');
            (<any>this.$root).$refs.dialogMessage.show({
                title: 'Онлайн-регистрация на рейс',
                text: 'К сожалению, данный функционал не поддерживается.',
                btnOkLabel: 'Закрыть',
                btnOkHandler: () => {
                    (<any>this).$ga.sendEvent('online.registration', 'btn.click', 'online.registration.btn.click.х');
                    this.isProductSelected = 'n';
                },
                btnCloseHandler: () => {
                    (<any>this).$ga.sendEvent('online.registration', 'btn.click', 'online.registration.btn.click.х');
                    this.isProductSelected = 'n';
                }
            });
        }
    }
}
